module.exports = __webpack_public_path__ + "img/coverage-2.ac923da6.svg";